export class ChangePassword {
    public LID: string;
    public NewPassword: string;
    public ConfirmNewPassword: string;
    public bearerToken: string;
    public Universalemail: string;

  }



// WEBPACK FOOTER //
// ./src/app/models/ChangePassword.ts